import * as React from "react";
import * as _ from "lodash";
import { connect } from "react-redux";
import { IAppointmentScheduleResponse } from "@curefit/care-common";
import { IAppState } from "../models/IAppState";
import { TwilioActions } from "../actions/TwilioActions";
import { ITwilioContext } from "../models/ITwilioContext";
import { LOADING_STATE } from "../utils/AppUtils";
import { AppConstants } from "../utils/AppConstants";
import ChatContainerWrapper from "../containers/TeleConsultation/ChatContainerWrapper";
import IPatientCompleteInfo from "../models/patients/IPatientCompleteInfo";
import { IAccessToken } from "../models/ICommunication";
import RollbarErrorTracking from "../utils/RollbarErrorTracking";


export interface NewTwilioComponentProps {
  doctorId: string;
}

interface NewTwilioStateToProps {
  twilioContext: ITwilioContext;
  appointments: IAppointmentScheduleResponse[];
  patientCompleteInfo: IPatientCompleteInfo;
  accessTokens: IAccessToken[];
}

interface NewTwilioDispatchToProps {
  updateChannelInfo: (IChannelInfo: any[]) => void;
  updateTotalUnreadCount: (unreadCount: number) => void;
  setCurrentChannel: (channel: any) => void;
  fetchChatContextAndInitTwilioClients: (doctorId: string) => void;
  updateUnreadMessageInfo: (newMessage : any,prevMessage : any) => void;
  channelsSynced: () => void;
  getUnreadMessagesInfo: (doctorId: string) => void;
  clearCurrentChannel: () => void;
}

export interface NewTwilioComponentState {
  syncStatus: LOADING_STATE;
  listernerInitiated: boolean;
}

class NewTwilioComponent extends React.Component<
  NewTwilioComponentProps & NewTwilioDispatchToProps & NewTwilioStateToProps,
  NewTwilioComponentState
> {
  private intervalFunction: any;

  constructor(
    props: NewTwilioComponentProps &
      NewTwilioDispatchToProps &
      NewTwilioStateToProps
  ) {
    super(props);
    this.state = {
      syncStatus: LOADING_STATE.NOT_INITIALIZED,
      listernerInitiated: false,
    };
  }

  componentWillUnmount() {

    if (
      !_.isEmpty(this.props.twilioContext.clients) 
    ) {
      const clients = this.props.twilioContext.clients;
      for (const client in clients) {
        this.removeListeners(clients[client]);
      }
    }
  }

  componentDidMount() {
    this.props.getUnreadMessagesInfo(this.props.doctorId);
    if (_.isEmpty(this.props.twilioContext.clients)) {
      this.props.fetchChatContextAndInitTwilioClients(this.props.doctorId);
    }
  }

  componentDidUpdate(): void {
    if (
      !_.isEmpty(this.props.twilioContext.clients) //&& !_.isEmpty(this.props.twilioContext.currentChannel.identity)
    ) {
      const clients = this.props.twilioContext.clients;
      if (!this.state.listernerInitiated)
        for (const client in clients) {
          this.removeListeners(clients[client]);
          clients[client].on("messageAdded", (newMessage: any) => {
            console.log(this.props.twilioContext);
            let identity = newMessage.state.author;
            if (identity.startsWith("Patient")) {
              const messageData: any = {
                patient: {
                  name: identity.slice(8),
                },
                twilioUnreadMessageCountView: {
                  channelSid: newMessage.conversation.sid,
                  lastMessageText: newMessage.state.body,
                  lastMessageTimestamp: newMessage.state.timestamp.getTime(),
                  memberIdentity: newMessage.configuration.userIdentity,
                  unreadMessageCount: 1,
                },
              };
              this.props.updateUnreadMessageInfo(
                messageData,
                JSON.parse(JSON.stringify(this.props.twilioContext.unreadMessageInfo))
              );
            }
          });
          this.setState({ listernerInitiated: true });
        }
    }
  }
  componentWillReceiveProps(
    nextProps: NewTwilioComponentProps &
      NewTwilioDispatchToProps &
      NewTwilioStateToProps
  ) {
    if (
      !_.isNull(nextProps.twilioContext.currentChannel.channelSid) &&
      _.isNull(nextProps.twilioContext.currentChannel.channel)
    ) {
      let channelSid = nextProps.twilioContext.currentChannel.channelSid;
      if (
        !_.isEmpty(nextProps.twilioContext.clients) &&
        !_.isEmpty(nextProps.twilioContext.currentChannel.identity)
      ) {
        console.time("initiateSetChannel");
        const clients = nextProps.twilioContext.clients;
        const memberIdentity = nextProps.twilioContext.currentChannel.identity;
        clients[memberIdentity] &&
          clients[memberIdentity]
            .getConversationBySid(channelSid)
            .then((channel: any) => {
              this.props.setCurrentChannel(channel);
            })
            .catch((e: any) => {
              RollbarErrorTracking.logErrorInRollbar(
                new Error("Error while loading channel from channelSid"),
                {
                  error: e,
                  channelSid,
                  doctorId: nextProps.doctorId,
                }
              );
            });
        // if (!_.isEmpty(memberIdentity)) {
        // } else {
        //     const clientsArr = _.map(nextProps.twilioContext.clients)
        //     let i: number = 0
        //     let channelFound: boolean = false;
        //     console.time(`setChannel`)
        //     for (i = 0; i < clientsArr.length; i++) {
        //         clientsArr[i].getChannelBySid(channelSid).then((channel: any) => {
        //             this.props.setCurrentChannel(channel)
        //             channelFound = true;
        //         }).catch((e: any) => {
        //         })
        //         if (channelFound) {
        //             break
        //         }
        //     }
        //     console.timeEnd("initiateSetChannel")
        // }
      }
    }
  }

  removeListeners = (activeChannel: any) => {
    if (activeChannel) {
      activeChannel.removeAllListeners();
    }
  };

  render() {
    let myInstance = this;
    let accessTokens = this.props.twilioContext.accessToken;
    let clientsLoading: boolean = _.isEmpty(this.props.twilioContext.clients);
    return (
      <div className={""}>
        {!_.isEmpty(myInstance.props.twilioContext.patient) &&
          !_.isEmpty(accessTokens) &&
          !_.isEmpty(myInstance.props.twilioContext.currentChannel) && (
            <ChatContainerWrapper
              patientId={myInstance.props.twilioContext.patient.id}
              stackToRight={true}
              userName={myInstance.props.twilioContext.patient.name}
              communicationAccessToken={accessTokens[0].tokenString}
              userIdentity={accessTokens[0].identity}
              chatChannelSid={
                myInstance.props.twilioContext.currentChannel.channelSid
              }
              clearCurrentChannel={myInstance.props.clearCurrentChannel}
              currentChannel={
                myInstance.props.twilioContext.currentChannel.channel
              }
              clientsLoading={clientsLoading}
            />
          )}
      </div>
    );
  }
}

const mapStateToProps = (state: IAppState): NewTwilioStateToProps => {
  let twilioContext = state.twilioContext;
  let appointments = state.allAppointments;
  let patientCompleteInfo = state.patientCompleteInfo;
  let accessTokens = state.chatAndVideoAccessTokens.chatAccessToken;
  return { twilioContext, appointments, patientCompleteInfo, accessTokens };
};

const mapDispatchToProps = (dispatch: any): NewTwilioDispatchToProps => {
  return {
    clearCurrentChannel: () => {
      return dispatch(TwilioActions.clearCurrentChannel());
    },
    getUnreadMessagesInfo: (doctorId: string) => {
      return TwilioActions.getUnreadMessageInfo(dispatch, doctorId);
    },
    updateUnreadMessageInfo: (newMessage: any,prevMessage : any) => {
      return TwilioActions.updateUnreadMessageInfo(dispatch, newMessage, prevMessage)
    },
    updateChannelInfo: (channelInfo: any[]) => {
      return dispatch(TwilioActions.updateChannelInfo(channelInfo));
    },
    updateTotalUnreadCount: (unreadCount: number) => {
      return dispatch(TwilioActions.updateTotalUnreadCount(unreadCount));
    },
    setCurrentChannel: (channel: any) => {
      return dispatch(TwilioActions.setCurrentChannel(channel));
    },
    fetchChatContextAndInitTwilioClients: (doctorId: string) => {
      return TwilioActions.fetchChatContextAndInitTwilioClients(
        dispatch,
        Number(doctorId)
      );
    },
    channelsSynced: () => {
      return dispatch(TwilioActions.channelsSyncComplete());
    },
  };
};

export default connect<
  NewTwilioStateToProps,
  NewTwilioDispatchToProps,
  NewTwilioComponentProps
>(
  mapStateToProps,
  mapDispatchToProps
)(NewTwilioComponent);
